import { DeskingSubmitOptions, SaleType } from 'modules/desking/types';
import { CreateLeadProposalVariables } from '../api/types';
import { CreditApplicationEntityType } from '@trnsact/trnsact-shared-types';

export function generateCreateLeadProposalLeadDTO(
  contact: DeskingSubmitOptions['form']['contact'],
  saleType: SaleType
): CreateLeadProposalVariables['input']['leadDTO'] {
  if (contact.selectedContact) {
    return {
      attach: contact.selectedContact,
    };
  }

  return {
    createData: {
      email: contact.email,
      phone: contact.phone,
      title: contact.title,
      fullName: contact.fullName ?? null,
      businessName: contact.businessName ?? null,
      saleEntityType: saleType === SaleType.Cash ? CreditApplicationEntityType.CashSale : undefined,
    },
  };
}
